<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string;
    disabled?: boolean;
  }>(),
  {
    text: "More",
    disabled: false,
  },
);

const showDropdown = ref(false);

const { authStore, displayUserName, attemptLogin } = useAuthApi();
const { isCurrentRouteLogin, signupRoute } = useAuthQueryParams();

const toggleDropdown = () => (showDropdown.value = !showDropdown.value);
const closeDropdown = () => (showDropdown.value = false);
</script>
<template>
  <div v-if="authStore.isAuthed" class="relative">
    <button
      class="size-8 text-sm uppercase rounded-full bg-nred-3 inline-flex items-center justify-center text-white shadow shadow-ngray-2 hover:bg-opacity-50"
      :class="{
        'opacity-50 pointer-events-none grayscale': disabled,
      }"
      :disabled
      @click="toggleDropdown"
    >
      <span>{{ authStore.currentAccountAvatarInitial }}</span>
    </button>
    <Transition name="fade" mode="out-in">
      <div
        v-if="showDropdown"
        v-click-outside="closeDropdown"
        class="absolute top-10 right-0 px-6 py-6 bg-white z-50 min-w-[100px] shadow-lg rounded"
      >
        <div class="flex flex-col gap-3">
          <div class="self-end text-sm text-gray-600 whitespace-nowrap">{{ displayUserName }}</div>
          <layout-dynamic-region region="userMenu" classes="contents" :binds="{ closeDropdown }" />
        </div>
      </div>
    </Transition>
  </div>
  <button-theme v-else-if="isCurrentRouteLogin" :to="signupRoute">
    <base-icon name="fa6-solid:right-to-bracket" class="mr-1" />
    <span>{{ $t("auth.signUp") }}</span>
  </button-theme>
  <button-theme v-else @click="attemptLogin">
    <base-icon name="fa6-solid:right-to-bracket" class="mr-1" />
    <span>{{ $t("auth.login") }}</span>
  </button-theme>
</template>
